<script>
import ItemComponent from './Item/component.vue';
import ServiceAdd from './ServiceAdd/component.vue';

export default {
  components: {
    ItemComponent,
    ServiceAdd,
  },
  props: {
    module: {
      type: Object,
    },
  },
  mounted() {
  },
  methods: {
    add(value) {
      this.open(this.module.handlerAdd(value));
    },
    remove(item) {
      this.module.remove(item);
    },
    edit(item) {
      this.open(item, true);
    },
    open(item, edit) {
      const donUseTariff = this.module.tariffs.tour.dontUseTariffs;
      // if(this.module.tariffs.tour.dontUseTariffs) {
      //   if (!item.servicePrices) {
      //     item.servicePrices = [];
      //   }
      //   item.tariffs = this.module.tariffs.data.filter(i => i.IsDefault);
      //   const defaultTariffTourId = item.tariffs[0].TariffId;
      //   let filter = item.servicePrices.filter(i => i.TourTariffId === defaultTariffTourId);
      //   if (!filter.length) {
      //     item.servicePrices.push({
      //       Id: 0,
      //       TourTariffId: item.tariffs[0].TariffId,
      //       HasVariants: false,
      //       IncludeInCost: true,
      //       IsCommissionService: true,
      //       IsGroupService: false,
      //       Netto: 0,
      //       AgentPrice: 0,
      //       ClientPrice: 0,
      //       HotelServicePrices: [],
      //       tariff: item.tariffs[0],
      //       Quota: 0,
      //     });
      //   }
      //   item.servicePrices = item.servicePrices.filter(i => i.TourTariffId === defaultTariffTourId)
      // }
      // else {
        item.tariffs = this.module.tariffs.data.map(x => {
          return {
            ...x,
            isShow: donUseTariff ? x.IsDefault : ! x.IsDefault,
          }
        });

        if (!item.servicePrices) {
          item.servicePrices = [];
        }

        for (const tariff of item.tariffs) {
          let filter = item.servicePrices.filter(i => i.TourTariffId === tariff.TariffId);
          if (!filter.length) {
            item.servicePrices.push({
              Id: 0,
              TourTariffId: tariff.TariffId,
              HasVariants: false,
              IncludeInCost: true,
              IsCommissionService: true,
              IsGroupService: false,
              Netto: 0,
              AgentPrice: 0,
              ClientPrice: 0,
              HotelServicePrices: [],
              tariff: tariff,
              Quota: 0,
              isShow: tariff.isShow
            });
          } else {
            filter[0].tariff = tariff;
            filter[0].isShow = tariff.isShow;
          }
        }

      const { data } = item;
      const serv = item.service.value
      const title = serv?.label || ''
      const width =  serv != null && serv.value == 3 ? 1200 : 900;
      this.$fDialog(item, {
        title: `${title}`,
        width: width,
      })
        .catch(() => {
          if (edit) {
            item.data = data;
          } else {
            this.remove(item);
          }
        });
    },
  },
};
</script>
<template>
  <Card>
    <CardTitle>
      Услуги
      <ServiceAdd
        slot="btn"
        :module="module.serviceAdd"
        @add="add"
      />
    </CardTitle>
    <ItemComponent
      v-for="(item, idx) in module.items"
      :key="idx"
      :module="item"
      @remove="remove(item)"
      @edit="edit(item)"
    />
    <CardNoLength v-if="!module.items.length">
      Добавьте услуги
    </CardNoLength>
  </Card>
</template>
<style lang="scss">

</style>
